const tier = process.env.REACT_APP_TIER ?? '';

export const isProduction = () => tier === 'prod';
